<template>
    <div v-loading="loading">
        <div class="block">
            <el-form class="form" label-width="100px" ref="ruleForm" :model="form" :rules="rules">
                <el-form-item label="维护状态：" prop="status">
                    <el-switch
                            v-model="form.status"
                            :active-value="1"
                            :inactive-value="0"/>
                </el-form-item>
                <el-form-item label="维护时间：" prop="date">
                    <el-date-picker
                            v-model="form.date"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"/>
                </el-form-item>
                <el-form-item label="示例：" prop="content">
                    <p>亲爱的玩家，服务器正在维护中，请稍后再试。预计维护时间 XX:XX-XX:XX。</p>
                    <p style="text-align: right">感谢您的理解和支持！</p>
                </el-form-item>

                <div class="footer">
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                form: {
                    id: null,
                    status: 0,
                    date: null
                },
                rules: {
                    date: [
                        {required: true, message: '请选择时间', trigger: 'blur'}
                    ]
                }
            }
        },
        created() {
            this.getData()
        },
        methods: {
            ...mapActions('maintain', ['getMessage', 'updateMessage']),
            getData() {
                this.loading = true;
                this.getMessage().then(res => {
                    this.loading = false;
                    if (res) {
                        this.form = {
                            id: res.id,
                            status: res.status,
                            date: [res.startTime, res.endTime]
                        }
                    } else {
                        this.form = {
                            id: null,
                            status: 0,
                            date: null
                        }
                    }
                })
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let params = {
                            id: this.form.id,
                            startTime: this.form.date[0],
                            endTime: this.form.date[1],
                            status: this.form.status
                        };
                        this.loading = true;
                        this.updateMessage(params).then(() => {
                            this.loading = false;
                            this.$message.success('提交成功');
                            this.getData()
                        })
                    }
                });
            },
        }
    }
</script>
<style lang="scss" scoped>
    .block {
        height: 500px;
    }

    .form {
        position: absolute;
        top: 15%;
        left: 50%;
        transform: translateX(-50%);
        width: 500px;

        :global(.el-date-editor) {
            width: 100% !important;
        }
    }

    .footer {
        padding: 20px 0 20px 100px;
        text-align: center;
        :global(.el-button) {
            width: 150px;
        }
    }
</style>